import { defaultActionCreator } from "../../actionCreator";

export const SET_STATE = "help/SET_STATE";
export const setState = defaultActionCreator(SET_STATE, "payload");

export const ADD_HELP = "ADD_HELP";
export const addHelp = defaultActionCreator(ADD_HELP, "data");
